// (() => {
// document.addEventListener('click', function(event) {
//         const buyButtons = event.target.closest('.buy-buttons');
//         if (buyButtons) {
//             const isFormValid = document.querySelector('[tpo-validated-form="false"]') === null;

//             if (!isFormValid) {
//                 const addToCartButton = document.querySelector('.tpo_add-to-cart');
//                 if (addToCartButton) {
//                     addToCartButton.click();
//                 }
//             }
//         }
//     });
// })();

// ─── Product Page: Accordion exclusive-open + smooth scroll ─────────────────
// Scoped strictly to .product-info__block-list so no other accordions on the
// site are affected (header sidebar, etc.).
(() => {
    const SCROLL_OFFSET = 75; // px from top of viewport to accordion header
    function scrollToAccordion(openedDisclosure, closingSiblings) {
        // Current position relative to viewport (snapshot before any animation)
        const openedRect = openedDisclosure.getBoundingClientRect();

        // Sum up how much content above us will collapse
        let freedAbove = 0;
        closingSiblings.forEach((sibling) => {
            const siblingRect = sibling.getBoundingClientRect();
            // Only count siblings that are visually above the opened accordion
            if (siblingRect.top >= openedRect.top) return;

            // Height of the collapsing content (summary stays, content goes)
            const contentEl = sibling.querySelector('.accordion__content');
            if (contentEl) {
                freedAbove += contentEl.offsetHeight;
            }
        });

        // Convert viewport-relative top → absolute document position,
        // then subtract the space that will disappear above us.
        const finalAbsoluteTop = window.scrollY + openedRect.top - freedAbove;
        const target = finalAbsoluteTop - SCROLL_OFFSET;

        window.scrollTo({ top: target, behavior: 'smooth' });
    }

    function initProductAccordions(blockList) {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (
                    mutation.type !== 'attributes' ||
                    mutation.attributeName !== 'aria-expanded'
                ) return;

                const details = mutation.target;

                // Only react when an accordion just opened
                if (details.getAttribute('aria-expanded') !== 'true') return;

                const openedDisclosure = details.closest('accordion-disclosure');
                if (!openedDisclosure) return;

                // 1. Collect open siblings BEFORE closing them (we need their heights)
                const closingSiblings = [];
                blockList.querySelectorAll('accordion-disclosure').forEach((disclosure) => {
                    if (disclosure === openedDisclosure) return;
                    const detailsEl = disclosure.querySelector('details');
                    if (detailsEl && detailsEl.getAttribute('aria-expanded') === 'true') {
                        closingSiblings.push(disclosure);
                    }
                });

                // 2. Scroll first (uses current layout snapshot + freed-height math)
                scrollToAccordion(openedDisclosure, closingSiblings);

                // 3. Now trigger close animations on siblings
                closingSiblings.forEach((disclosure) => {
                    if (typeof disclosure.close === 'function') {
                        disclosure.close();
                    }
                });
            });
        });

        // Observe aria-expanded on every details inside accordion-disclosures
        blockList.querySelectorAll('accordion-disclosure details').forEach((details) => {
            observer.observe(details, { attributes: true, attributeFilter: ['aria-expanded'] });
        });
    }

    function setup() {
        customElements.whenDefined('accordion-disclosure').then(() => {
            document.querySelectorAll('.product-info__block-list').forEach((blockList) => {
                initProductAccordions(blockList);
            });
        });
    }

     window.customVariantState = window.customVariantState || new Map();
    // Storage for the original add_to_cart button text
    window.customSubmitText = window.customSubmitText || new Map();

    // Get translation from Liquid. If missing, use fallback string
    let missingText = window.themeVariables.strings.selectYourSize;
    if (!missingText || missingText.includes('translation missing')) {
      missingText = "Select your size";
    }

    function setupVariantPicker(picker) {
      if (!picker) return;
      const formId = picker.getAttribute('form-id');
      if (!formId) return;

      const fieldsets = picker.querySelectorAll('fieldset.variant-picker__option');
      if (!fieldsets.length) return;

      // Initialize storage for the specific product/form
      if (!window.customVariantState.has(formId)) {
        window.customVariantState.set(formId, new Map());
      }
      
      const selectedState = window.customVariantState.get(formId);
      // Find the add to cart button (usually has the .button class)
      let submitButton = document.querySelector(`form#${formId} button[type="submit"].button`) || document.querySelector(`button[type="submit"][form="${formId}"].button`);
      if (!submitButton) {
        submitButton = document.querySelector(`form#${formId} button[type="submit"]`) || document.querySelector(`button[type="submit"][form="${formId}"]`);
      }

      // Save the original button text once
      if (submitButton && !window.customSubmitText.has(formId)) {
        const textElement = submitButton.querySelector('span:not(.icon)') || submitButton;
        window.customSubmitText.set(formId, textElement.textContent.trim());
      }

      // 1. Ensure all available option keys are tracked
      // data-color-switch is set by Liquid when _cs=1 is in the request URL.
      // This is reliable even for async-loaded external scripts because the
      // flag lives in the DOM, not the URL.
      const isColorSwitch = picker.hasAttribute('data-color-switch');
      fieldsets.forEach((fieldset, index) => {
        const optionKey = `option${index + 1}`;
        // On color switch: always reinitialize from the HTML checked inputs —
        // even if this formId was previously cached (e.g. returning to a product
        // visited earlier with a different size). Without this, the stale cached
        // value would be restored instead of the freshly fetched variant.
        if (!selectedState.has(optionKey) || isColorSwitch) {
          if (isColorSwitch) {
            const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
            selectedState.set(optionKey, checkedInput ? checkedInput.value : null);
          } else {
            selectedState.set(optionKey, null);
          }
        }
      });

      // 2. Restore states
      fieldsets.forEach((fieldset, index) => {
        const optionKey = `option${index + 1}`;
        const inputs = fieldset.querySelectorAll('input[type="radio"]');
        const savedValue = selectedState.get(optionKey);

        inputs.forEach(input => {
          const label = picker.querySelector(`label[for="${input.id}"]`);
          
          if (savedValue !== null && input.value === savedValue) {
             input.checked = true;
             if (label) label.classList.add('selected', 'is-selected');
             const valueSpan = fieldset.querySelector('.variant-picker__option-info .h-stack span');
             if (valueSpan && label) valueSpan.textContent = label.textContent.trim();
          } else {
             input.checked = false;
             input.removeAttribute('checked');
             if (label) label.classList.remove('selected', 'is-selected');
          }

          if (input.dataset.customListener !== 'true') {
            input.dataset.customListener = 'true';
            
            input.addEventListener('change', (e) => {
              if (e.target.checked) {
                inputs.forEach(i => {
                  const l = picker.querySelector(`label[for="${i.id}"]`);
                  if (l) l.classList.remove('selected', 'is-selected');
                });
                
                if (label) label.classList.add('selected', 'is-selected');
                selectedState.set(optionKey, input.value);

                const valueSpan = fieldset.querySelector('.variant-picker__option-info .h-stack span');
                if (valueSpan && label) valueSpan.textContent = label.textContent.trim();

                // Check overall selection completeness
                checkAllSelected(selectedState, fieldsets, submitButton, picker, formId);
              }
            });

            if (label) {
              label.addEventListener('click', (e) => {
                if (!input.checked) {
                  input.checked = true;
                  input.dispatchEvent(new Event('change', { bubbles: true }));
                }
              });
            }
          }
        });
      });

      // Bind click interceptor to the cart button (if not already bound)
      if (submitButton && submitButton.dataset.customInterceptor !== 'true') {
        submitButton.dataset.customInterceptor = 'true';
        submitButton.addEventListener('click', (e) => {
          // If the form is not valid yet
          if (submitButton.dataset.ready === 'false') {
            e.preventDefault();
            e.stopImmediatePropagation();

            // Find the first unselected fieldset and animate it
            for (let i = 0; i < fieldsets.length; i++) {
              if (selectedState.get(`option${i + 1}`) === null) {
                const fs = fieldsets[i];
                
                const optionValuesContainer = fs.querySelector('.variant-picker__option-values') || fs;
                const labels = fs.querySelectorAll('.block-swatch, .color-swatch, .thumbnail-swatch, button.select, label');
                
                // Shake for the wrapper
                if (optionValuesContainer) {
                  optionValuesContainer.classList.remove('variant-picker-shake');
                  void optionValuesContainer.offsetWidth; // Trigger reflow
                  optionValuesContainer.classList.add('variant-picker-shake');
                  // setTimeout(() => optionValuesContainer.classList.remove('variant-picker-shake'), 1000);
                }

                // Flash for the labels/swatches
                labels.forEach(label => {
                  label.classList.remove('variant-picker-flash');
                  void label.offsetWidth; // Trigger reflow
                  label.classList.add('variant-picker-flash');
                  // setTimeout(() => label.classList.remove('variant-picker-flash'), 1000);
                });

                // Scroll to the unselected option
                fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
                break; // Highlight only the first unselected option
              }
            }
          }
        }, true); // Use capture phase to intercept before native theme scripts
      }

      // Check the state
      checkAllSelected(selectedState, fieldsets, submitButton, picker, formId);
    }

    function checkAllSelected(selectedState, fieldsets, submitButton, picker, formId) {
      if (!submitButton) return;
      
      let isAllSelected = true;

      for (let i = 0; i < fieldsets.length; i++) {
        if (selectedState.get(`option${i + 1}`) === null) {
          isAllSelected = false;
          break;
        }
      }

      const textElement = submitButton.querySelector('span:not(.icon)') || submitButton;
      const originalText = window.customSubmitText.get(formId) || 'Add to cart';

      if (!isAllSelected) {
        // There are unselected options
        submitButton.dataset.ready = 'false';
        submitButton.disabled = false; // We don't disable it so the user can click and see the animation!
        // Always show the hardcoded string/translation
        textElement.textContent = missingText;
      } else {
        // All options are selected
        submitButton.dataset.ready = 'true';
        submitButton.disabled = false;
        textElement.textContent = originalText;
      }
    }

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          for (const node of mutation.addedNodes) {
             if (node.nodeType !== Node.ELEMENT_NODE) continue;
             
             if (node.matches && node.matches('.variant-picker')) {
               setupVariantPicker(node);
             } else if (node.tagName === 'FIELDSET' && node.classList.contains('variant-picker__option')) {
               const picker = node.closest('.variant-picker');
               if (picker) setupVariantPicker(picker);
             } else if (node.querySelector) {
               const pickers = node.querySelectorAll('.variant-picker');
               pickers.forEach(setupVariantPicker);
             }
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', setup);
        document.addEventListener('DOMContentLoaded', () => {
            document.querySelectorAll('.variant-picker').forEach(setupVariantPicker);
        });
    } else {
        setup();
        document.querySelectorAll('.variant-picker').forEach(setupVariantPicker);
    }
})();

if (!customElements.get('product-color-switcher')) {
class ProductColorSwitcher extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this._onItemClick.bind(this));
  }

  disconnectedCallback() {
    this.removeEventListener('click', this._onItemClick.bind(this));
  }

  _getCurrentOptions() {
    const picker = document.querySelector('variant-picker');
    if (!picker) return [];

    const options = [];

    picker.querySelectorAll('fieldset.variant-picker__option').forEach((fieldset) => {
      const selectedLabel = fieldset.querySelector('label.selected, label.is-selected');
      if (selectedLabel) {
        const text = selectedLabel.textContent?.trim() || null;
        if (text) { options.push(text); return; }
      }

      // Fallback: checked radio input (native browser state)
      const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
      if (checkedInput) {
        const label = picker.querySelector(`label[for="${checkedInput.id}"]`);
        const text = label?.textContent?.trim() || null;
        if (text) { options.push(text); return; }
      }
    });

    return options;
  }

  _findMatchingVariant(targetProduct, currentOptions) {
    const variants = targetProduct.variants;

    if (!variants || !variants.length) return { variant: null, exact: false };

    if (!currentOptions || !currentOptions.length) {
      return { variant: variants.find((v) => v.available) || variants[0], exact: false };
    }

    const exact = variants.find((v) => {
      const vOpts = v.options || [v.option1, v.option2, v.option3].filter(Boolean);
      return currentOptions.every((opt, i) => vOpts[i] === opt);
    });
    if (exact) return { variant: exact, exact: true };

    const partialMatch = variants.find((v) => {
      const vOpts = v.options || [v.option1, v.option2, v.option3].filter(Boolean);
      return vOpts[0] === currentOptions[0];
    });
    if (partialMatch) return { variant: partialMatch, exact: false };

    return { variant: variants.find((v) => v.available) || variants[0], exact: false };
  }

  async _onItemClick(e) {
    const item = e.target.closest('.product_colors__item');
    if (!item || item.classList.contains('active')) return;

    const targetUrl = item.dataset.url;
    if (!targetUrl) return;

    const groupScript = document.querySelector('script[data-products-group]');
    if (!groupScript) return;

    let productsGroup;
    try {
      productsGroup = JSON.parse(groupScript.textContent);
    } catch (e) {
      return;
    }

    const urlHandle = targetUrl.replace(/^\/+|\/+$/g, '').split('/').pop().split('?')[0];
    const targetProduct = productsGroup.find((p) => p.handle === urlHandle);

    const currentOptions = this._getCurrentOptions();
    const { variant: matchedVariant, exact: isExactMatch } = targetProduct
      ? this._findMatchingVariant(targetProduct, currentOptions)
      : { variant: null, exact: false };

    // Preserve the 'view' parameter from the current URL or data-attribute for A/B testing
    const currentUrlParams = new URLSearchParams(window.location.search);
    const viewParam = currentUrlParams.get('view') || this.dataset.template;
    
    let baseTargetUrl = targetUrl;
    let targetUrlParams = new URLSearchParams();
    
    if (targetUrl.includes('?')) {
      const [path, search] = targetUrl.split('?');
      baseTargetUrl = path;
      targetUrlParams = new URLSearchParams(search);
    }
    
    if (viewParam) {
      targetUrlParams.set('view', viewParam);
    }

    if (matchedVariant) {
      targetUrlParams.set('variant', matchedVariant.id);
    }

    let cleanUrl = baseTargetUrl;
    const targetQueryString = targetUrlParams.toString();
    if (targetQueryString) {
      cleanUrl += '?' + targetQueryString;
    }

    const fetchUrl = isExactMatch ? cleanUrl + (cleanUrl.includes('?') ? '&' : '?') + '_cs=1' : cleanUrl;

    this._setLoading(true);

    try {
      const response = await fetch(fetchUrl);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newMain = doc.getElementById('main');
      const currentMain = document.getElementById('main');

      if (!newMain || !currentMain) {
        window.location.href = fetchUrl;
        return;
      }

      currentMain.innerHTML = newMain.innerHTML;

      window.history.pushState({}, '', cleanUrl);

      newMain.querySelectorAll('script').forEach((oldScript) => {
        const newScript = document.createElement('script');
        [...oldScript.attributes].forEach((attr) => newScript.setAttribute(attr.name, attr.value));
        newScript.textContent = oldScript.textContent;
        document.head.appendChild(newScript).parentNode.removeChild(newScript);
      });

      // Re-initialize Reviews widget
      window.okeWidgetApi.initAllWidgets()

      // Notify theme to re-initialize components
      document.dispatchEvent(new CustomEvent('page:load', { bubbles: true }));
    } catch (err) {
      window.location.href = fetchUrl;
    } finally {
      this._setLoading(false);
    }
  }

  _setLoading(state) {
    const main = document.getElementById('main');
    if (main) main.style.opacity = state ? '0.5' : '';
    this.querySelectorAll('.product_colors__item').forEach((item) => {
      item.style.pointerEvents = state ? 'none' : '';
    });
  }
}

customElements.define('product-color-switcher', ProductColorSwitcher);
}
